(() => {
  if (customElements.get('wolf-card-gallery')) return;

  class WolfCardGallery extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const source = this.querySelector('[data-card-gallery]');
      if (!source) return;
      let data;
      try { data = JSON.parse(source.textContent); } catch { return; }
      if (!Array.isArray(data.images) || data.images.length < 2) return;
      this.media = this.querySelector('[class$="__media"]');
      this.primary = this.media?.querySelector('img');
      if (!this.primary) return;
      this.initialized = true;
      this.images = data.images;
      this.productTitle = data.title;
      this.color = data.color;
      this.index = 0;
      this.requested = 0;
      this.manualIndex = 0;
      this.loaded = new Map();
      this.hoverIndex = this.images.findIndex((image, index) => index > 0 && image.label === 'Back');
      this.classList.add('wolf-card-gallery--ready');

      const controls = document.createElement('div');
      controls.className = 'wolf-card-gallery__controls';
      controls.setAttribute('role', 'group');
      controls.setAttribute('aria-label', `${data.title} photos${data.color ? `, ${data.color}` : ''}`);
      // Controls are siblings of the product link, never buttons inside an anchor.
      controls.innerHTML = '<button type="button" data-card-prev><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m14 6-6 6 6 6"/></svg></button><span data-card-caption></span><button type="button" data-card-next><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m10 6 6 6-6 6"/></svg></button>';
      this.append(controls);
      this.caption = controls.querySelector('[data-card-caption]');
      this.status = document.createElement('span');
      this.status.className = 'wolf-card-gallery__status';
      this.status.dataset.cardStatus = '';
      this.status.setAttribute('aria-live', 'polite');
      this.append(this.status);
      this.prev = controls.querySelector('[data-card-prev]');
      this.next = controls.querySelector('[data-card-next]');
      this.prev.addEventListener('click', () => this.step(-1));
      this.next.addEventListener('click', () => this.step(1));
      this.media.addEventListener('pointerenter', event => {
        if (event.pointerType === 'touch' || !window.matchMedia('(hover: hover) and (pointer: fine)').matches || this.hoverIndex < 0) return;
        this.hovering = true;
        this.show(this.hoverIndex, false);
      });
      this.media.addEventListener('pointerleave', () => {
        if (!this.hovering) return;
        this.hovering = false;
        this.show(this.manualIndex, false);
      });
      this.updateCaption();
    }

    step(direction) {
      this.hovering = false;
      // Use the last displayed view so rapid clicks cannot race an uncommitted image.
      const index = (this.index + direction + this.images.length) % this.images.length;
      this.show(index, true);
    }

    show(index, announce) {
      this.requested = index;
      this.announce = announce;
      if (announce) this.status.textContent = '';
      if (index === 0 || this.loaded.get(index)?.ready) {
        this.commit(index);
        return;
      }
      if (this.loaded.has(index)) return;
      const image = document.createElement('img');
      image.dataset.cardAlternate = '';
      image.hidden = true;
      image.alt = `${this.productTitle}${this.color ? `, ${this.color}` : ''}, ${this.images[index].label.toLowerCase()} view`;
      image.width = 900;
      image.height = 900;
      const state = { image, ready: false };
      this.loaded.set(index, state);
      image.addEventListener('load', () => {
        state.ready = true;
        if (this.requested === index) this.commit(index);
      }, { once: true });
      image.addEventListener('error', () => {
        this.loaded.delete(index);
        image.remove();
        if (this.requested !== index) return;
        this.requested = this.index;
        if (this.announce) this.status.textContent = 'Photo could not load. Try the arrow again.';
      }, { once: true });
      this.primary.parentElement.append(image);
      image.src = this.images[index].src;
    }

    commit(index) {
      this.index = index;
      for (const [key, state] of this.loaded) state.image.hidden = key !== index;
      this.primary.style.visibility = index === 0 ? '' : 'hidden';
      if (this.announce) {
        this.manualIndex = index;
        this.status.textContent = `${this.images[index].label} view${this.color ? `, ${this.color}` : ''}. Photo ${index + 1} of ${this.images.length}.`;
      }
      this.updateCaption();
    }

    updateCaption() {
      const label = this.index === 0 && this.hoverIndex > 0 ? 'View back' : this.images[this.index].label;
      this.caption.textContent = `${label} ${this.index + 1}/${this.images.length}`;
      this.prev.setAttribute('aria-label', `Previous photo of ${this.productTitle}`);
      this.next.setAttribute('aria-label', `Next photo of ${this.productTitle}`);
    }
  }

  customElements.define('wolf-card-gallery', WolfCardGallery);
})();
